import { useLoaderData, useNavigate } from 'react-router';
import { useInfo } from '../context/useInfo';
import NotFound from './NotFound';
import SmallArticleItem from '../components/SmallArticleItem';

function TagView() {
    const { info } = useInfo();
    const { articles, tag } = useLoaderData();

    const navigate = useNavigate();

    if (tag == null || tag["errorCode"] == 404) return <NotFound />

    return <>
        {info && <button className='group' onClick={() => navigate('/dashboard/create/category', { state: { id: tag["category_id"], ...tag } })}>
            <img src="/images/pencil.png" className='w-8 inline-block pr-1 group-hover:saturate-0' alt="editor icon" />
            <span className='align-middle group-hover:font-semibold'>Edit</span>
        </button>}
        <div>
            <img src="/images/folder.png" alt="dash icon" className='inline w-16 aspect-square mr-4' />
            <h2 className='inline text-3xl font-semibold mb-2 align-middle'>{`Tag: ${tag.name}`}</h2>
        </div>
        <p>{tag.description}</p>
        <h2 className='text-2xl font-semibold mb-2 mt-4 align-middle'>Tagged articles:</h2>
        {articles && articles.map((item: Record<string, any>, index: number) => {
            return <SmallArticleItem key={index} article={item} />
        })}
    </>
}

export default TagView